/**
 * Client portal Bio: the client's per-platform profile copy. The client id
 * comes from the portal JWT. The server ignores the IG handle and the FB
 * page name on write; `canEdit` is false for brief-share and creator sessions.
 */

import type { HttpClient } from "@/core/http/types";
import { SocialPlatform, SocialProfile, SocialProfiles } from "@/types";

export interface PortalSocialProfiles {
  socialProfiles: SocialProfiles;
  canEdit: boolean;
}

const SOCIAL_PROFILES_URL = "/api/client-portal/social-profiles";

export const portalSocialProfilesService = {
  get(http: HttpClient): Promise<PortalSocialProfiles> {
    return http.get<PortalSocialProfiles>(SOCIAL_PROFILES_URL);
  },

  update(
    http: HttpClient,
    platform: SocialPlatform,
    profile: SocialProfile,
  ): Promise<PortalSocialProfiles> {
    return http.patch<PortalSocialProfiles>(SOCIAL_PROFILES_URL, { socialProfiles: { [platform]: profile } });
  },
};
